jQuery(document).ready(function () {
  jQuery('.js-agend-copy-input').on('click', function (e) {

    const form$ = jQuery(this).closest('form');
    const result$ = form$.find('.js-agend-copy-input-result');
    const value = form$.find('input').val();

    function showSuccessResult( result ) {
      result$.removeClass('d-none').addClass('copy-input-action--success').show().css('opacity', '1').text( result );
      setTimeout( function() {
        result$.fadeOut( 'slow', function() {
          jQuery(this).removeClass('copy-input-action--success').addClass('d-none');
        });
      }, 5000 );
    }

    function showErrorResult( result ) {
      result$.removeClass('d-none').addClass('copy-input-action--error').show().css('opacity', '1').text( result );
      setTimeout( function() {
        result$.fadeOut( 'slow', function() {
          jQuery(this).removeClass('copy-input-action--error').addClass('d-none');
        });
      }, 5000 )
    }

    let objectName = 'value';
    objectDataName = jQuery(this).data('name');
    if ( objectDataName ) {
      objectName = objectDataName;
    }

    let msgFail = `Failed to copy ${objectName}.`;
    if (!window.navigator) {
      showErrorResult(msgFail);
    }

    navigator.clipboard.writeText(value)
      .then(() => {
        showSuccessResult( `Successfully copied ${objectName} to your clipboard.` );
      })
      .catch(err => {
        showErrorResult(msgFail + ': ' + err);
      });
  });
});
